
<app-warning *ngIf="isAuthenticated()"></app-warning>
<router-outlet></router-outlet>